"use client"

import Text from "@/components/common/Typography/Text"
import { useTETranslation } from "@/hooks/app/useTETranslation"
import { TypeAirport } from "@/lib/redux/features/flight/type"
import { faCity } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { FC } from "react"

type SearchingCityHeaderProps = {
  airport: TypeAirport
}

const SearchingCityHeader: FC<SearchingCityHeaderProps> = ({ airport }) => {
  const { getAirportCityName } = useTETranslation()
  const label = getAirportCityName(airport)

  return (
    <div className="home__searching--placement-city-header">
      <FontAwesomeIcon icon={faCity} className="home__searching--placement-header-icon" aria-hidden />
      <Text className="home__searching--placement-city-header-text">{label}</Text>
    </div>
  )
}

SearchingCityHeader.displayName = "SearchingCityHeader"

export default SearchingCityHeader
